<template>
  <v-card>
    <div class="d-flex pa-2 align-center channel">
      <v-card-title class="headline white--text">Allowed users</v-card-title>
      <v-btn class="ml-auto" icon @click="close()">
        <v-icon small class="white--text">mdi-window-close</v-icon>
      </v-btn>
    </div>
    <v-card-text>
      <v-row>
        <v-col cols="12" sm="12">
          <v-card outlined class="mt-1">
            <v-card-title>
              From Channel Groups
              <v-btn class="ml-auto" icon> </v-btn>
            </v-card-title>
            <v-divider class="mb-5"></v-divider>
            <v-list-item-group multiple>
              <v-list-item-content
                class="pa-0 pl-4 ma-0 pt-2"
                v-for="(item, i) in groups"
                :key="i"
              >
                <v-checkbox
                  class="pa-0 ma-0"
                  v-model="selectedGroups"
                  @click="changeSelectedGroup(item)"
                  color="primary"
                  :label="item.group_name"
                  :value="item.id"
                ></v-checkbox>
              </v-list-item-content>
            </v-list-item-group>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { listGroups } from "@/graphql/Query";
export default {
  data: () => ({
    contentSearch: "",
    users: [],
    userSearch: "",
    numberOfResgisterGroups: "",
    groups: "",
    headers: [{ align: "start", text: "Email", value: "email" }],
    showChannelGroups: true,
    selectedGroups: [],
    selectedGroupIds: []
  }),
  props: ["content_id", "who_groups"],
  async mounted() {
    await this.init();
    console.log("selectedGroups", this.selectedGroups);
  },
  methods: {
    close() {
      console.log("close");
      this.$emit("onCloseContentUsersDialog");
    },
    async init() {
      // 그룹목록 가져오기
      console.log("contentAllowdUser init at mounted");
      await this.getListGroups();
      // 기존 선택된 그룹을 체크처리
      console.log("init");
      console.log(this.who_groups);
      this.selectedGroupIds = this.who_groups ? this.who_groups : [];
      this.who_groups.forEach(group => {
        const items = group.split("#");
        const group_id = items[1];
        this.groups.forEach(g => {
          if (g.id == group_id) {
            this.selectedGroups.push(g.id);
          }
        });
      });
      console.log("초기화 완료", this.selectedGroupIds, this.selectedGroups);
    },
    changeSelectedGroup(item) {
      console.log("0", item);

      const channel_id = this.$store.state.channelId;

      if (item.id == "") {
        this.selectedGroups = [""];
      } else {
        this.selectedGroups = this.selectedGroups.filter(item => {
          console.log({ item });
          return item != "";
        });
      }

      console.log("111", this.selectedGroups);
      this.selectedGroupIds = this.selectedGroups.map(item => {
        if (item == "") {
          return channel_id + "##gu";
        } else {
          return channel_id + "#" + item + "#gu";
        }
      });
      console.log("최종 그룹 ids", this.selectedGroupIds);
      console.log("최종 그룹 groups", this.selectedGroups);
      this.$emit("onUpdateGroups", this.selectedGroupIds);
    },
    async getListGroups() {
      /**
       * 채널에 해당하는 그룹목록 가져오기
       */
      const limit = undefined;
      const nextToken = undefined;
      const channelId = this.$store.state.channelId;
      try {
        const { data } = await this.$apollo.query({
          query: listGroups,
          variables: {
            channel_id: channelId,
            limit: limit,
            nextToken: nextToken
          },
          fetchPolicy: "no-cache"
        });
        const all = {
          channel_id: channelId,
          group_name: "All Channel Users",
          id: ""
        };
        const tempGroups = data.listGroups.items;
        tempGroups.sort((a, b) => (a.group_name > b.group_name ? 1 : -1));
        this.groups = [all, ...tempGroups];
        console.log(this.groups);
      } catch (e) {
        console.log("[GroupList] listGroup failed");
      }
    }
  }
};
</script>
